<template>
  <div class="index-bottom">
    <div class="container-width">
      <div class="content clearfix">
        <div class="fl">
          <div class="font-s36">联系我们</div>
          <div class="font-s18 pd-t-20"><img src="../../src/assets/image/phone.png" class="middle">4008-068-222</div>
          <div class="font-s18 pd-t-20"><img src="../../src/assets/image/address.png" class="middle">浙江省杭州市新世界铂悦轩</div>
          <div class="font-s18 pd-t-20"><img src="../../src/assets/image/enterpriseName.png" class="middle">杭州泛康医学集团</div>
        </div>
        <div class="fr text-center">
          <div class="font-s36">关于我们</div>
          <div style="padding-top:36px">
            <img src="../assets/image/code.jpg" width="128">
          </div>
          <div class="font-s18 pd-10">泛众睡眠好医生平台</div>
        </div>
      </div>
      <div class="text-center records  font-s14">
        <div class="footTwoCopyright">COPYRIGHT © 2018 杭州泛众网络科技有限公司 版权所有
          <a target="_blank" href="http://beian.miit.gov.cn/?spm=a2c4g.11186623.7y9jhqsfz.110.778d7dc6Dm18Zb" style="cursor: pointer;font-size: 14px; color: #ffffff;">浙ICP备：18049890号</a>
           <a target="_blank" href="https://www.fcsleep.com/hlwypxxzs.png" style="cursor: pointer;font-size: 14px; color: #ffffff;margin-left:8px"> | 互联网药品信息服务资格证 </a>
        </div>
        <div class="pd-t-20">
          <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010802009538"
            style="display:inline-block;text-decoration:none;height:20px;line-height:20px;cursor: pointer;">
            <img src="../assets/image/bei.png" style="float:left;">
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#ffffff;">浙公网安备 33010802009538号</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {},
};
</script>

<style lang="scss">
.index-bottom {
  background: #333333;
  padding: 80px 0;
  .content {
    color: #ffffff;
    img {
      margin-right: 20px;
    }
  }
  .records {
    color: #ffffff;
  }
}
</style>
